const AUTH_MESSAGES: Record<string, string> = {
  "auth/email-already-in-use": "Ese email ya tiene una cuenta. Probá ingresar.",
  "auth/invalid-email": "Revisá el email: parece estar incompleto.",
  "auth/invalid-credential": "El email o la contraseña no coinciden.",
  "auth/wrong-password": "El email o la contraseña no coinciden.",
  "auth/user-not-found": "El email o la contraseña no coinciden.",
  "auth/user-disabled": "Esta cuenta está deshabilitada. Escribinos a soporte.",
  "auth/operation-not-allowed": "Este método de ingreso todavía no está habilitado en Firebase.",
  "auth/unauthorized-domain": "THOT todavía no está autorizado en Firebase para este dominio. Agregá thot-gc.pages.dev en dominios autorizados.",
  "auth/invalid-api-key": "La configuración pública de Firebase no es válida. Revisá la configuración del sitio.",
  "auth/app-not-authorized": "La aplicación web todavía no está autorizada en Firebase.",
  "auth/argument-error": "La configuración de acceso social de Firebase no está completa todavía.",
  "auth/web-storage-unsupported": "El navegador bloqueó el almacenamiento local. Permití cookies y almacenamiento para THOT GC.",
  "auth/internal-error": "Google no pudo abrir el acceso en este navegador. Abrí THOT GC directamente en Chrome, Edge o Firefox y probá de nuevo.",
  "auth/weak-password": "Elegí una contraseña de al menos 10 caracteres.",
  "auth/too-many-requests": "Hubo varios intentos. Esperá unos minutos y volvé a probar.",
  "auth/popup-closed-by-user": "Cerraste la ventana antes de terminar.",
  "auth/popup-blocked": "El navegador bloqueó la ventana de acceso. Permitila y probá otra vez.",
  "auth/network-request-failed": "No pudimos conectarnos. Revisá tu conexión y volvé a intentar.",
  "auth/account-exists-with-different-credential": "Ese email ya usa otro método de ingreso.",
};

export function friendlyError(error: unknown): string {
  const code =
    typeof error === "object" && error !== null && "code" in error
      ? String((error as { code: unknown }).code)
      : "";
  if (AUTH_MESSAGES[code]) return AUTH_MESSAGES[code];
  if (error instanceof Error && error.message.startsWith("THOT:")) {
    return error.message.slice(5);
  }
  if (code) return `Firebase no pudo iniciar el acceso (código: ${code}).`;
  return "No pudimos completar la acción. Tus datos siguen seguros; probá de nuevo.";
}
